export default __webpack_public_path__ + "static/Entenda0068-0eaae7de2cf270b68acd63d9b52b0980.jpg";